import React from "react"
import { Col, Row, Form } from "react-bootstrap"
import { getIn } from "formik"
import NumberFormat from "react-number-format"
import FormLabel from "./formLabel"
import * as CommonFunction from "../../common/function"

function FormAmountTextBox(props) {
  const { textDesc, form, field, placeholder, maxLength, decimalScale } = props

  const errorsMsg = getIn(form.errors, field.name)
  //const touched = getIn(form.touched, field.name)

  const inputErrorClassName = (touched, errors, inputName) => {
    // return (clickedNext && errors[inputName]) ||
    return errors[inputName] && touched[inputName] ? "is-invalid" : null
  }

  const inputErrorMessage = (touched, errors, inputName) => {
    // return (clickedNext && errors[inputName]) ||
    return errors[inputName] && touched[inputName] ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  return (
    <div className="marginBottom19px">
      <FormLabel text={textDesc} />
      <div className="marginTop10px">
        <NumberFormat
          disabled={props.disabled}
          thousandSeparator=","
          decimalSeparator="."
          decimalScale={typeof decimalScale !== "undefined" ? decimalScale : 2}
          // thousandSeparator={true}
          // decimalSeparator={true}
          //format="#######.##"
          name={field.name}
          className={
            "d-block inputbox text-right " +
            props.addClassName +
            " " +
            inputErrorClassName(form.touched, form.errors, field.name)
          }
          type="text"
          maxLength={maxLength ? maxLength : 14}
          autoComplete="new-password"
          value={field.value || ""}
          placeholder={placeholder ? placeholder : "0.00"}
          onChange={e => {
            let value = e.target.value
            value = CommonFunction.convertStringToDecimal(value)
            form.handleChange(e)
            form.setFieldValue(field.name, value)
          }}
          onBlur={e => {
            let value = e.target.value
            value = CommonFunction.convertStringToDecimal(value)
            form.handleBlur(e)
            if (value) {
              form.setFieldValue(field.name, value)
            } else {
              form.setFieldValue(field.name, 0)
            }
          }}
        />
        {/* {errors && touched && <span className="InputError">{errors}</span>} */}
        {inputErrorMessage(form.touched, form.errors, field.name)}
      </div>
    </div>
  )
}
export default FormAmountTextBox
